module.exports = __webpack_public_path__ + "img/Im going there.24c9f713.png";